import React, { useContext, useState } from 'react'
import { SocialMediaLink, Dialog } from '@aok/ui-elements'

import { PrivacyContext } from '../../../context/PrivacyContext'

const SocialMediaChannel = {
  FACEBOOK: 'facebook',
}

const ArticleSharing = () => {
  const { socialMedia } = useContext(PrivacyContext)
  const [overlayIsOpen, setOverlayIsOpen] = useState(false)
  // const [previousActiveElement, setPreviousActiveElement] = useState(null)
  const [selectedSocialMedia, setSelectedSocialMedia] = useState(null)

  // action for sharing on facebook
  const fbAction = () => {
    const url = 'https://www.facebook.com/sharer.php?display=popup&u=' + window.location.href
    const options = 'resizable, innerWidth=600, innerHeight=500'
    window.open(url, 'sharer', options)
  }

  const handleAction = () => {
    switch (selectedSocialMedia) {
      case SocialMediaChannel.FACEBOOK:
        fbAction()
        break

      default:
        break
    }
  }

  const showPrivacyDialog = (socialMediaChannel) => {
    setOverlayIsOpen(true)
    setSelectedSocialMedia(socialMediaChannel)
  }

  const closeDialog = () => {
    setOverlayIsOpen(false)
  }

  return (
    <div className="flex justify-center gap-24 600:gap-32">
      <SocialMediaLink
        type={SocialMediaChannel.FACEBOOK}
        className="shareFacebook"
        data-tracking-name="Facebook"
        onClick={() => showPrivacyDialog(SocialMediaChannel.FACEBOOK)}
      />
      <Dialog
        data-social-media={selectedSocialMedia}
        data-tracking-name="T005"
        {...socialMedia}
        actionLabel="Ich stimme zu"
        cancelLabel="Ich stimme nicht zu"
        onAction={handleAction}
        onCancel={closeDialog}
        onClose={closeDialog}
        isOpen={overlayIsOpen}
      />
    </div>
  )
}

ArticleSharing.propTypes = {}

export default ArticleSharing
